import { useEffect, useState, useMemo, useCallback } from "react";
import WebSocketManager from "../../../../ws/client";

export function useParentLiveUpdate(initialClient) {
  const [liveClient, setLiveClient] = useState(initialClient);

  useEffect(() => {
    setLiveClient(initialClient);
  }, [initialClient]);

  const parentId = useMemo(() => {
    return initialClient?.id_parent;
  }, [initialClient]);

  const topic = useMemo(() => {
    if (!parentId) return null;
    return `/topic/parent-${parentId}`;
  }, [parentId]);

  const handleMessage = useCallback((event) => {
    try {
      const { type, payload } = event;
      if (type === "UPDATED" && payload) {
        setLiveClient(payload);
      }

    } catch (err) {
      console.error("Erro ao processar update live do responsável:", err);
    }
  }, []);

  useEffect(() => {
    if (!topic) return;

    WebSocketManager.subscribe(topic, handleMessage);

    return () => {
      WebSocketManager.unsubscribe(topic);
    };
  }, [topic, handleMessage]);

  return liveClient;
}